module.exports = __webpack_public_path__ + "img/JAOC_POP_MozzarellaCheese_square.4851eb11.png";